import { SharedGridConfig } from "app/modules/shared/ag-grid/shared-grid-state/shared-grid.model";
import { Offer, OfferComponent } from "./offers.model";

export class OnGetOffers {
  static readonly type = '[Offers] Get Offers';
  constructor(public payload: { gridUUID: string; }) { }
}

export class GetNewOfferNumber {
  static readonly type = '[Offers] Get New Offer Number';
}

export class SetOffersFormGridConfig {
  static readonly type = '[Offers] Set Offers Form Grid Config';
  constructor(public payload: { gridUUID: string; thirdGridConfig: SharedGridConfig; }) { };
}

export class SaveOffer {
  static readonly type = '[Offers] Save';
}

export class OnSetNewOfferComponent {
  static readonly type = '[Offers] Add New Offers Component';
}

export class SetSelectedOffer {
  static readonly type = '[Offers] Set Selected Offer';
  constructor(public payload: { _id: string, md5Checksum: string; clone?: boolean; }) { }
}

export class SetSelectedOfferGridData {
  static readonly type = '[Offers] Set Selected Offer Grid Data';
  constructor(public payload: { _id: string, md5Checksum: string; }) { }
}

export class GetOfferStatuses {
  static readonly type = '[Offers] Get Offer Statuses';
}

export class OnSetOfferStatus {
  static readonly type = '[Offers] On Set Offer Status';
}

export class IsOfferEditable {
  static readonly type = '[Offers] Is Offer Editable';
  constructor(public payload: boolean) { }
}

export class IsOfferComponentEditable {
  static readonly type = '[Offers] Is Offer Component Editable';
  constructor(public payload: boolean) { }
}

export class OnActionOffer {
  static readonly type = '[Offers] Update Offers';
}

export class CloneOffer {
  static readonly type = '[Offers] Clone Offer';
  constructor(public payload: Offer) { }
}

export class OnRemoveOffer {
  static readonly type = '[Offers] Remove Offer';
  constructor(public payload: { offerId: string; }) { }
}

export class OnRemoveOfferComponent {
  static readonly type = '[Offers] Remove Offer Component';
  constructor(public payload: { offerComponentId?: string; offerComponent?: OfferComponent; }) { }
}

export class GetOfferCustomers {
  static readonly type = '[Offers] Get Offer Customers';
}
export class GetOfferTerms {
  static readonly type = '[Offers] Get Offer Terms';
  constructor(public payload: string) { }
}

export class SetIsNew {
  static readonly type = '[Offers] Set If Offer is New';
  constructor(public payload: boolean) { }
}

export class GetTobaccoTypes {
  static readonly type = '[Offers] Get Tobacco Types';
}

export class GetTobaccoType {
  static readonly type = '[Offers] Get Tobacco Types';
}

export class GetOfferOrigins {
  static readonly type = '[Offers] Get Offer Origins';
}

export class ExportOffers {
  static readonly type = '[Offers] Export Offers';
}

//** Cell Renderer */
export class SetOffersComponentsGridConfig {
  static readonly type = '[Offers] Set Offers Components Grid Config';
  constructor(public payload: { gridUUID: string, gridConfig: any; }) { }
}

export class OnSetCurrentOrderRenderer {
  static readonly type = '[Offers] On Set Current Order Renderer';
  constructor(readonly payload: { currentRenderer: string; }) { }
}
export class GetOfferComponentsById {
  static readonly type = '[Offers] Get Offer Components By Id';
  constructor(public payload: { parentId: string; gridUUID: string; }) { }
}

export class SetSelectedOfferComponent {
  static readonly type = '[Offer] Set Selected Offer Component';
  constructor(readonly payload: any) { }
}

//** Webhooks */

export class UpdatedOfferWebhook {
  static readonly type = '[Offer] Document updated';
  constructor(readonly payload: any) { }
}